export const STRIPE = process.env.REACT_APP_STRIPE_KEY || "";
export const PAYPAL_ID = "";
